$(document).ready(function(){
  addLabelInCart()

  /* SEND TO SIZE GUIDE TAB */
  $(".size_guide").click(function(){
    if($(window).width() > 768){
      $("#size_guide_tab").click();
      $('html, body').animate({
          scrollTop: $("#size_guide_tab").offset().top - 200
      }, 100); 
    }else{
      $("#product-sizeguide").click();
      $('html, body').animate({
          scrollTop: $("#product-sizeguide").offset().top - 150
      }, 100); 
    }
      
  })

  if($(window)[0].outerWidth < 768){
      
    $("#block-template--19751218839878__product-content-description button").attr("aria-expanded","false");
    $("#block-template--19751218839878__product-content-description-content").removeAttr("open");
    $("#block-template--19751218839878__product-content-description-content").css("overflow", "hidden");
  }

  let lang = "";
  if(window.location.href.includes("/pt")){
    lang = "/pt"
  }else if (window.location.href.includes("/es")){
    lang = "/es"
  }else if (window.location.href.includes("/fr")){
    lang = "/fr"
  }else{
    lang= ""
  }


  

  /*******************************/
  /*** APPLY CHECKOUT DISCOUNT ***/
  /*******************************/
  
  $(".accept_terms").click(function(){
    if($(this).prop("checked") == true){
      $(".cart__checkout-button").removeAttr("disabled")
      $(".cart__checkout-button").click(function(){
        //document.cookie = 'discount_code='+$(".customer_discount").attr("value");
        //$(".cart__recap").attr("action", encodeURI("/checkout?discount="+$(".customer_discount").attr("value"))).submit();  
        $(".cart__recap").submit();
      })    
    }else{
      $(".cart__checkout-button").attr("disabled", true)
    }
  })
  
  
  /***************************/
  /*** NOT LOGGED REDIRECT ***/
  /***************************/
  
  if (Shopify.designMode == undefined) {
   const targetUrl = "/account/login";
    const currentUrl = window.location.href;
    if($(".customer_logged").attr("value") == 'NO_CUSTOMER' ){
      if (currentUrl.includes(targetUrl) || currentUrl.includes("/challenge") || currentUrl.includes("/password")  || currentUrl.includes("/account/activate") || currentUrl.includes("/account/reset") || currentUrl.includes("/account/invalid_token")) {
        //NO REDIRECT
      }else{
        window.location.href=targetUrl
      }
    }
  }
   

  /*************************/
  /*** MARKETS REDIRECT ***/
  /************************/
  
  var market = $(".customer_market").attr("value");
  var language = $(".customer_language").attr("value");
  var url = window.location.href;
  let redirect = language+"-"+market;
  if(market == 'pt' && language == 'en'){
    redirect = ''
  }else if(market == 'pt' && language == 'pt'){
    redirect = 'pt'
  }

  

  if (Shopify.designMode == undefined) {    
    if(market != undefined && language != undefined ){
      
      if(url.includes("https://b2b.giannikavanagh.com/"+redirect)){
        //same url
      }else{
        let current_path = url.split(".com")[1];
        if(market == 'pt' && language == 'en'){
          window.location.href="https://b2b.giannikavanagh.com/"+current_path  
        }else{
          window.location.href="https://b2b.giannikavanagh.com/"+redirect+current_path    
        }
      }
    }
  }

   /***********************************/
   /*** COOKIE DELETE PREORDER CART ***/
   /***********************************/
   /*
  var cart_time=Cookies.get("cart_time");
  
  var cart_expire = (60*1000) *60*72 // 24 horas
  */
  /*if (cart_time>0 && cart_time<( Date.now() - cart_expire)){
     $.getJSON('/cart/clear.js', function(cart) {
        Cookies.set('cart_time', Date.now(),{ expires: 365 });
       console.log("CART REMOVED");
       updateCart()
     })
     console.log("CART EXPIRED");
  }
  
  Cookies.set('cart_time', Date.now(),{ expires: 365 });*/
  
  /*
  var preorder_time=Cookies.get("preorder_time");
  var preorder_expire = (60*1000) *60*72 // 72 horas

  if (preorder_time>0 && preorder_time<( Date.now() - preorder_expire)){
    console.log("PREORDER CART EXPIRED");
  	$.get(ENDPOINT+"/b2b/cart.php", { clear:window.customerId,t:Math.random(1,999999999) })
    .done(function(data) {
      if (data==1){
        console.log("Carrinho de Preorder Eliminado");
        location.reload()
      } else {
        console.log("Não foi possível eliminar devido a um erro de ligação. Tente novamente!");
      }
    }).fail(function( data) {
     console.log("Não foi possível eliminar devido a um erro de ligação. Tente novamente!");
    });
  } 
  
  Cookies.set('preorder_time', Date.now(),{ expires: 365 });
*/
   /*******************************/
   /*** COLLECTIONS LOOK LOGICS ***/
   /*******************************/

  if(window.location.href.includes("?look") && $(".shopify-section--main-product").length > 0){
    
    let look = window.location.href.split("?")[1];
    let count = look.split("&")[1]
    
    look = look.split("&")[0];
    
    let lang = "";
    let back_to_look = "";
    if(window.location.href.includes("/pt")){
      lang = "/pt"
      if(look.includes("for-men")){
        back_to_look = "Voltar para o "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("men","Homen")
      }else{
        back_to_look = "Voltar para o "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("women","Mulher")
      }
    }else if (window.location.href.includes("/es")){
      lang = "/es"
      if(look.includes("for-men")){
        back_to_look = "Volver a "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("men","Hombre")
      }else{
        back_to_look = "Volver a "+look.replaceAll("-", " ").replace("l", "L").replace("for","para").replace("women","Mujer")
      }
    }else if (window.location.href.includes("/fr")){
      lang = "/fr"
      if(look.includes("for-men")){
        back_to_look = "Retour au "+look.replaceAll("-", " ").replace("l", "L").replace("for","pour").replace("men","Homme")
      }else{
        back_to_look = "Retour au "+look.replaceAll("-", " ").replace("l", "L").replace("for","pour").replace("women","Femme")
      }
    }else{
      lang = ""
      if(look.includes("for-men")){
        back_to_look = "Back to "+look.replaceAll("-", " ").replace("l", "L").replace("men","Men")
      }else{
        back_to_look = "Back to "+look.replaceAll("-", " ").replace("l", "L").replace("women","Women")
      }
    }

    //console.log(back_to_look)
  
    let svg_arrow_left = `<svg focusable="false" width="15px" height="15px" class="{{ icon_class }}" viewBox="0 0 17 14">
        <path d="M17 7H2M8 1L2 7l6 6" stroke="currentColor" stroke-width="{{ settings.icon_stroke_width }}" fill="none"></path>
      </svg>`;
    let html = `<a class="breadcrumb__link" href="`+lang+`/collections/`+look+`?`+count+`">`+look.replace("-", " ").replace("l", "L") +`</a>`;
    let html2 = `<div class="my-3"><a class="breadcrumb__link" style="text-align:right" href="`+lang+`/collections/`+look+`?`+count+`"><h5> `+svg_arrow_left + `<span class="back_to_look">`+ back_to_look +`</span></h5></a></div>`
    $(".breadcrumb__item.look-breadcrumb").append(html);
    $(html2).insertBefore($(".product-meta__vendor"));
    $(".breadcrumb__item.look-breadcrumb").removeClass("d-none");
  }

  let url_count = window.location.href;
  if(url_count.includes("count=")){
    url_count = url_count.split("?")[1];

    $(".product-item-content").each(function(){
      let handle = $(this).find(".product-image a").attr("href")
      $(this).find(".product-image a").attr("href",handle+"&"+url_count )
      $(this).find(".product-item-meta a").attr("href",handle+"&"+url_count )
      $(this).find(".prod-item-title a").attr("href",handle+"&"+url_count )  
    })
    
    
    let url_count_value = url_count.split("=")[1]
    let look_number = $(".collection_title h2").attr("data-look");
    
    
    if(parseInt(look_number) == parseInt(url_count_value)){
      $(".collection_title .next_look").addClass("d-none");
    }else if(parseInt(look_number) == 1){
      $(".collection_title .previous_look").addClass("d-none");
    }
    
    let previous_look = parseInt(look_number)-1;
    let next_look = parseInt(look_number)+1;
    
    let gender = "men"
    if(window.location.href.includes("-for-men")){
      gender = "men"
    }else if(window.location.href.includes("-for-women")){
      gender = "women"
    }

    let previous_url = lang+"/collections/look-"+previous_look+"-for-"+gender+"?count="+url_count_value;
    let next_url = lang+"/collections/look-"+next_look+"-for-"+gender+"?count="+url_count_value;
    
    /*$(".previous_look").attr("href",previous_url)
    $(".next_look").attr("href",next_url)*/

    $(".next_look").click(function(){
      window.location.assign("https://b2b.giannikavanagh.com/"+next_url)
    })

    $(".previous_look").click(function(){
      window.location.assign("https://b2b.giannikavanagh.com/"+previous_url)
    })
  
    $(".collection_title").removeClass("d-none")
  }else{
    $(".collection_title").removeClass("d-none")
  }
});

/**************************/
/*** ADD TO CART LOGICS ***/
/**************************/

function addToCartPreOrder(item) {

    let variants = $(item).parent().parent().parent().find(".product-item-variants .qntyInputs input");

  let formData = {
    items: []
  };

  variants.each(function() {
    let input = $(this);
    let quantity = parseInt(input.val());
    
    if (quantity >= 1) {
      let variantId = input.attr("data-v-id");
      let variantData = {
        id: variantId,
        quantity: quantity
      };

      formData.items.push(variantData);
    }
  });

  console.log(formData)
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error('Error adding item to cart');
    }
  })
  .then(data => {
    setTimeout(function() {
       $.getJSON('/cart.js', function(cart) {
         console.log(cart)
          $(".header__cart-count").html(cart.item_count);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
          //upsellplusapp.init_drawer_offer();
       });

   }, 200);

    const regex = new RegExp('[a-zA-Z]{2}-[a-zA-Z]{2}');
    let urlMarkets = window.location.href;
    urlMarkets = urlMarkets.split("/");
    let urlSplit = urlMarkets[3];
    let hasMarket = regex.test(urlSplit)


   let lang = "";
   let added_to_cart = "Added to cart"
   let view_cart = "View Cart"
    let close = "Close";
   if(window.location.href.includes("/pt")){
     lang = "/pt"
     added_to_cart = "Adicionado ao carrinho"
     view_cart = "Ver Carrinho"
     close = "Fechar"
   }else if (window.location.href.includes("/es")){
     lang = "/es"
     added_to_cart = "Añadido al Carrito"
     view_cart = "Ver Carrito"
     close = "Cerrar"
   }else if (window.location.href.includes("/fr")){
     lang = "/fr"
     added_to_cart = "Ajouté au Panier"
     view_cart = "Mon Panier"
     close = "Fermer"
   }else if(hasMarket){
       lang = "/"+urlSplit
     }
  
    var success = `<div class="cart-notification__overflow">
        <div class="container">
          <div class="cart-notification__wrapper">
            <svg focusable="false" width="20" height="20" class="icon icon--cart-notification" viewBox="0 0 20 20">
              <rect width="20" height="20" rx="10" fill="currentColor"></rect>
              <path d="M6 10L9 13L14 7" fill="none" stroke="rgb(var(--success-color))" stroke-width="2"></path>
            </svg>
            
            <div class="cart-notification__text-wrapper">
              <span class="cart-notification__heading heading hidden-phone">`+added_to_cart+`</span>
              <span class="cart-notification__heading heading hidden-tablet-and-up">`+added_to_cart+`</span>
              <a href="`+lang+`/cart" class="cart-notification__view-cart link">`+view_cart+`</a>
            </div>
            <button class="cart-notification__close tap-area hidden-phone" data-action="close">
              <span class="visually-hidden">`+close+`</span>
              <svg focusable="false" width="14" height="14" class="icon icon--close icon--inline" viewBox="0 0 14 14">
                <path d="M13 13L1 1M13 1L1 13" stroke="currentColor" stroke-width="2" fill="none"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>`;

    $(".cart-notification")[0].innerHTML = success;
    $(".cart-notification").removeAttr("hidden");

    $(".qntyInputs input").each(function(){
      $(this).val("")
    });

    $(".variant-total input").each(function(){
      $(this).val("")
    });

    $(".product-item-variants .w-100 span").each(function(){
      //console.log($(this))
      $(this)[0].innerText = "0"
    });
    
    
  })
  .catch(error => {
    console.error('Error:', error);
  });
}

/*****************************/
/*** INPUT QUANTITY CHANGE ***/
/*****************************/

function qntyChanged(input) {
  var parent_ = $(input).parent().parent().parent()[0];
   
  input.value = input.value.replace(/[^0-9]/g, '');
  
  if (input.value === '') {
    input.value = 0;
  }

  if(parseInt(input.value) > parseInt($(input).attr("max"))){
    input.value = parseInt($(input).attr("max"));
  }
  
  let totalQnty = 0;
  
  $(parent_).find(".qntyInputs").each(function(){
    if($(this).find("input").val() == ''){
      
    }else{
      totalQnty += parseInt($(this).find("input").val())  
    }
  })

  let total_ammount = totalQnty * $(parent_).find("#totalQnty").attr("data-price");
  let formatted_ammount = total_ammount.toLocaleString('pt-PT', {
    style: 'currency',
    currency: 'EUR'
  });

  $(parent_).find(".total_value")[0].innerText = formatted_ammount
  
  $(parent_).find(".variant-total input").val(totalQnty)

}


  /***************************/
  /*** LABEL ADDED TO CART ***/
  /***************************/
function addLabelInCart(){
  fetch("/cart.js")
    .then((res) => {
      if (res.ok) {
        return res.json()
      }
    })
    .then(({ items }) => {
      const skusList = []
      items.forEach(({ sku, variant_id, quantity }) => {
      document.querySelectorAll(`[data-v-id="${variant_id}"]`).forEach((quantityInput) => {
        const stock = Number(quantityInput.dataset.stockMax || quantityInput.max)
        quantityInput.dataset.stockMax = stock
        const remaining = Math.max(0, stock - quantity)
        quantityInput.max = remaining
        quantityInput.disabled = remaining === 0
      })
        const filteredSku = sku.split("#")[0]
        skusList.push(filteredSku)
      })

      const productList = document.querySelectorAll(".product-item-content")
      const productItem = document.querySelector(".product")

      const showProductLabel = (p) => {
        const itemSku = p.querySelector(".prod-item-sku")?.innerText ?? ""

        if (skusList.includes(itemSku)) {
          const itemLabel = p.querySelector(".product_in_cart")
      if (itemLabel) itemLabel.classList.remove("d-none")
          
        }
      }

      if (productItem) showProductLabel(productItem)

      productList.forEach((p) => showProductLabel(p))
    })
}